"use client"

import { useEffect } from "react"
import { useTheme } from "next-themes"

interface ThemeToggleProps {
  collapsed?: boolean
  showLabel?: boolean
}

export function ThemeToggle({ collapsed = false, showLabel = true }: ThemeToggleProps) {
  const { setTheme } = useTheme()

  // Force light theme on component mount
  useEffect(() => {
    setTheme("light")
  }, [setTheme])

  // Return null to completely hide the component
  return null
}